<!-- <script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@vueuse/core';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import LiveChatCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/LiveChatCampaign/LiveChatCampaignDialog.vue';
import EditLiveChatCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/LiveChatCampaign/EditLiveChatCampaignDialog.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import LiveChatCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/LiveChatCampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const editLiveChatCampaignDialogRef = ref(null);
const confirmDeleteCampaignDialogRef = ref(null);
const selectedCampaign = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const [showLiveChatCampaignDialog, toggleLiveChatCampaignDialog] = useToggle();

const liveChatCampaigns = computed(
  () => getters['campaigns/getLiveChatCampaigns'].value
);

const hasNoLiveChatCampaigns = computed(
  () => liveChatCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleEdit = campaign => {
  selectedCampaign.value = campaign;
  editLiveChatCampaignDialogRef.value.dialogRef.open();
};
const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.LIVE_CHAT.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.LIVE_CHAT.NEW_CAMPAIGN')"
    @click="toggleLiveChatCampaignDialog()"
    @close="toggleLiveChatCampaignDialog(false)"
  >
    <template #action>
      <LiveChatCampaignDialog
        v-if="showLiveChatCampaignDialog"
        @close="toggleLiveChatCampaignDialog(false)"
      />
    </template>

    <div
      v-if="isFetchingCampaigns"
      class="flex justify-center items-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <CampaignList
      v-else-if="!hasNoLiveChatCampaigns"
      :campaigns="liveChatCampaigns"
      is-live-chat-type
      @edit="handleEdit"
      @delete="handleDelete"
    />
    <LiveChatCampaignEmptyState
      v-else
      :title="t('CAMPAIGN.LIVE_CHAT.EMPTY_STATE.TITLE')"
      :subtitle="t('CAMPAIGN.LIVE_CHAT.EMPTY_STATE.SUBTITLE')"
      class="pt-14"
    />
    <EditLiveChatCampaignDialog
      ref="editLiveChatCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template> -->


<!-- 
<
<template>
  <div class="h-screen w-screen">
 
    <div
      v-if="!selectedApp"
      class="flex flex-col items-center justify-center h-full gap-4 bg-gray-100 dark:bg-slate-900"
    >
      <button
        class="w-64 px-6 py-3 bg-woot-700 text-white rounded hover:bg-green-700 transition"
        @click="selectedApp = 'link1'"
      >
        Unicesumar
      </button>
      <button
        class="w-64 px-6 py-3 bg-woot-700 text-white rounded hover:bg-green-700 transition"
        @click="selectedApp = 'link2'"
      >
        Dinâmica
      </button>
    </div>


    <iframe
      v-else
      :src="iframeSrc"
      class="w-full h-full border-none"
      frameborder="0"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedApp: null,
    };
  },
  computed: {
    iframeSrc() {
      return (
        {
          link1: 'https://appclaudete.virtuacrm.app',
          link2: 'https://appdinamica.virtuacrm.app',
        }[this.selectedApp] || ''
      );
    },
  },
};
</script> -->

<template>
  <div class="h-screen w-screen">
    <!-- Tela de escolha -->
    <div
      v-if="!selectedKey"
      class="flex flex-col items-center justify-center h-full gap-4 bg-gray-100 dark:bg-slate-900"
    >
      <!-- Há apps configurados? Mostra botões dinâmicos -->
      <template v-if="hasApps">
        <button
          v-for="app in apps"
          :key="app.key"
          class="w-64 px-6 py-3 bg-woot-700 text-white rounded hover:bg-green-700 transition"
          @click="selectedKey = app.key"
        >
          {{ app.label }}
        </button>
      </template>

      <!-- Nenhum app? Mostra CTA de aquisição -->
      <template v-else>
        <button
          class="w-72 px-8 py-4 bg-woot-700 text-white rounded hover:bg-green-700 transition"
          @click="handleAcquire"
        >
          Adquira agora seu Módulo Gestão
        </button>
      </template>
    </div>

    <!-- Iframe ocupa a tela após escolha -->
    <iframe
      v-else
      :src="currentUrl"
      class="w-full h-full border-none"
      frameborder="0"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const withScheme = url =>
  url && !/^https?:\/\//i.test(url) ? `https://${url}` : url;

export default {
  name: 'AppLauncher',

  data() {
    return { selectedKey: null };
  },

  computed: {
    ...mapGetters('accounts', ['getAccount']),

    /** Atributos customizados da conta corrente */
    customAttributes() {
      const accountId = Number(this.$route.params.accountId);
      return this.getAccount(accountId)?.custom_attributes || {};
    },

    /** Lista de apps realmente disponíveis */
    apps() {
      return [1, 2].flatMap(i => {
        const url   = withScheme(this.customAttributes[`link${i}`]);
        const label = this.customAttributes[`labellink${i}`] || `App ${i}`;
        return url ? [{ key: `link${i}`, label, url }] : [];
      });
    },

    hasApps() {
      return this.apps.length > 0;
    },

    /** URL atual do iframe */
    currentUrl() {
      return this.apps.find(a => a.key === this.selectedKey)?.url || '';
    },
  },

  methods: {
    handleAcquire() {
      // Substitua pela rota, modal ou página que faz sentido no seu produto
      window.open('https://virtuacrm.com.br', '_blank', 'noopener');
    },
  },
};
</script>
